export type SpeakerCardProps = {
  firstName: string;
  lastName: string;
  role?: string;
  title: string;
  description: string;
  image: string;
};

const SpeakerCard = (props: SpeakerCardProps) => {
  return (
    <div className="speakers-card-wrapper">
      {props.image && (
        <div className="speakers-card-img">
          <img src={props.image} height="100%" width="100%" alt={props.firstName} />
        </div>
      )}
      <span className="first-name">{props.firstName} {props.lastName}</span>
      {props.role && (
        <div>
          {props.role}
        </div>
      )}
      <br></br>
      <span className="last-name">{props.title}</span>
      <p dangerouslySetInnerHTML={{ __html: props.description }} />
    </div>
  );
};

export default SpeakerCard;
